import { useContext } from "react";
import { SmartMenuContext } from "./smartMenuContext";
import { useNavigation } from "@refinedev/core";

export const useSmartMenuLink = () => {
  const { setSmartMenuType, setSmartMenuName } = useContext(SmartMenuContext);
  const { push } = useNavigation();

  const goToSmartMenu = ({
    menuType,
    menuName,
    url = "operators",
  }: {
    menuType: "sellers" | "stores";
    menuName: string;
    url?: string;
  }) => {
    setSmartMenuType(menuType);
    setSmartMenuName(menuName);
    push(`/${menuType}/${url}/${menuName}`);
  };

  return { goToSmartMenu };
};
